export default "__VITE_ASSET__cd68002a__"